var React = require('react');

function Phone (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"phone--android-phone-mobile-device-smartphone-iphone"},React.createElement("path",{"id":"Intersect","stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round","d":"M9.177 1.48c.71-.596 1.768-.51 2.307.244.144.201.314.441.609.81a3.508 3.508 0 0 1-.006 4.366c-.752.932-1.54 1.873-2.422 2.754-.882.882-1.823 1.67-2.755 2.423a3.508 3.508 0 0 1-4.366.005c-.393-.314-.638-.485-.846-.634-.729-.52-.83-1.54-.262-2.23.45-.547.95-1.067 1.432-1.576.385-.405 1.027-.431 1.463-.083.117.094.263.217.558.494 1.45-.861 2.329-1.75 3.175-3.174a9.007 9.007 0 0 1-.499-.564c-.348-.436-.322-1.076.086-1.457.496-.464 1.002-.94 1.526-1.378Z"})));
}

Phone.defaultProps = {"fill":"none","viewBox":"0 0 14 14","height":"18","width":"18"};

module.exports = Phone;

Phone.default = Phone;
